import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import {
  GET_FORM,
  GET_CLIENT_INFO,
} from '../constants/ActionTypes'

import {
  showMessage,
  getFormSuccess,
  getClientInfoSuccess,
} from '../actions/Form'

import { SERVER_IP } from '../constants/Config'
import { getClientInfo as getClientInfoUtil } from '../util/General'

const getFormRequest = async form_id =>
  await fetch(`${SERVER_IP}/api/forms/${form_id}`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // 'x-access-token': localStorage.getItem('token'),
      // 'app-secret': APP_SECRET,
      Pragma: 'no-cache',
    },
    method: 'GET',
    credentials: 'include',
  })
    .then(response => response.json())
    .catch(error => error)

const getClientInfoRequest = async () =>
  await getClientInfoUtil()

/** ***** Calls ***** */
function* getFormCall({ payload }) {
  try {
    const response = yield call(getFormRequest, payload)
    if (response.auth === null || response.auth !== false)
      yield put(getFormSuccess(response))
  } catch (error) {
    yield put(showMessage(JSON.stringify({ status: 'error', message: error })))
  }
}

function* getClientInfoCall({ payload }) {
  try {
    const response = yield call(getClientInfoRequest, payload)
    if (response.auth === null || response.auth !== false)
      yield put(getClientInfoSuccess(response))
  } catch (error) {
    yield put(showMessage(JSON.stringify({ status: 'error', message: error })))
  }
}

/** **** takeEvery Functions *** */
export function* getForm() {
  yield takeEvery(GET_FORM, getFormCall)
}

export function* getClientInfo() {
  yield takeEvery(GET_CLIENT_INFO, getClientInfoCall)
}

export default function* rootSaga() {
  yield all([
    fork(getForm),
    fork(getClientInfo),
  ])
}
